/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/function-component-definition */
import React, { useRef, useState, useEffect } from 'react';
import Webcam from 'react-webcam';
import { Modal, Button, Spin, message } from 'antd';
import './style.css'; // Updated styles for human pose overlays

const WebCamDialog = ({ visible, onClose, onCapture, pose }) => {
  const webcamRef = useRef(null);
  const [shutterEffect, setShutterEffect] = useState(false);
  const [cameraLoading, setCameraLoading] = useState(true);
  const [cameraError, setCameraError] = useState(false);

  const stopCamera = () => {
    if (webcamRef.current && webcamRef.current.stream) {
      const tracks = webcamRef.current.stream.getTracks();
      tracks.forEach((track) => track.stop());
    }
  };

  useEffect(() => {
    const checkCameraAvailability = async () => {
      setCameraLoading(true);
      try {
        await navigator.mediaDevices.getUserMedia({ video: true });
        setCameraError(false);
      } catch (err) {
        setCameraError(true);
        message.error('Camera not available or permission denied.');
      } finally {
        setCameraLoading(false);
      }
    };

    if (visible) {
      checkCameraAvailability();
    } else {
      stopCamera();
    }

    return () => {
      stopCamera();
    };
  }, [visible]);


  const capture = () => {
    if (webcamRef.current) {
      setShutterEffect(true); // Trigger shutter effect
      setTimeout(() => setShutterEffect(false), 300); // Remove effect after 300ms
      const imageSrc = webcamRef.current.getScreenshot();
      onCapture(imageSrc);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={() => {
        stopCamera();
        onClose();
      }}
      footer={null}
      centered
      width={600}
      className={`webcam-dialog ${shutterEffect ? 'shutter' : ''}`}
    >
      <div className="webcam-container">
        {cameraLoading ? (
          <div className="camera-loading">
            <Spin size="large" />
            <p>{cameraError ? 'Camera not available' : 'Loading Camera...'}</p>
          </div>
        ) : (
          <>
            {!cameraError && (
              <>
                {/* Webcam feed */}
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  className="webcam-feed"
                  imageSmoothing
                  screenshotQuality={1}
                  width={1200}          // High portrait resolution
                  height={1800}
                  onUserMedia={() => setCameraLoading(false)}
                  onUserMediaError={() => {
                    setCameraLoading(false);
                    setCameraError(true);
                    message.error('Camera not available or permission denied.');
                  }}
                />
                {/* Overlay frame based on pose */}
                {/* <div className={`overlay-frame pose-frame `} /> */}
              </>
            )}
          </>
        )}
      </div>
      <div className="actions">
        <Button
          type="primary"
          onClick={capture}
          disabled={cameraLoading || cameraError}
        >
          Capture
        </Button>
        <Button
          onClick={() => {
            stopCamera();
            onClose();
          }}
          disabled={cameraLoading}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default WebCamDialog;
